"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SideBar = void 0;
var _react = require("react");
var _hooks = require("../../../hooks");
var _SideBar = require("./SideBar.labels");
var _SideBarListItem = require("./Partials/SideBarListItem");
var _Menu = require("../../../UI/Menu");
var _Icon = require("../../../UI/Icon");
var _Site = require("../Site.config");
var _SideBar2 = _interopRequireDefault(require("./SideBar.styles"));
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const SideBar = props => {
  const {
    items,
    maxMobileItems = 5,
    expandOnHover = false
  } = props;
  const {
    isMobileView
  } = (0, _hooks.useDeviceData)();
  const {
    pxToRem
  } = (0, _hooks.useStylesUtils)();
  const getLabel = (0, _hooks.useLabels)({
    labels: _SideBar.labels
  });
  const styles = (0, _SideBar2.default)(expandOnHover);
  const menuRef = (0, _react.useRef)(null);
  let btnProps = {};
  let listItems = [...items];
  let menuItems = [];
  if (isMobileView && listItems.length > maxMobileItems) {
    listItems = items.slice(0, maxMobileItems - 1);
    menuItems = items.slice(maxMobileItems - 1);
    btnProps = {
      shape: 'rectangle',
      view: 'alternate',
      color: 'basic',
      customStyle: {
        width: '100%',
        height: pxToRem(_Site.sidebarHeight)
      },
      children: /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
        className: styles['cc-SideBar__menu__item__more-btn'],
        children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_Icon.Icon, {
          name: "More"
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
          children: getLabel('more')
        })]
      })
    };
  }
  const handleItemClick = () => {
    if (menuRef.current) {
      menuRef.current.closeMenu();
    }
  };
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_jsxRuntime.Fragment, {
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)("aside", {
      className: styles['cc-SideBar'],
      "aria-label": getLabel('sidebarAriaLabel'),
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)("nav", {
        children: /*#__PURE__*/(0, _jsxRuntime.jsxs)("ul", {
          className: styles['cc-SideBar__menu'],
          children: [listItems && listItems.map((item, i) => {
            const itemProps = {
              item,
              expandOnHover
            };
            return /*#__PURE__*/(0, _jsxRuntime.jsx)(_SideBarListItem.SideBarListItem, {
              ...itemProps
            }, i);
          }), isMobileView && menuItems.length && /*#__PURE__*/(0, _jsxRuntime.jsx)("li", {
            className: styles['cc-SideBar__menu__item'],
            children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Menu.Menu, {
              btnProps: btnProps,
              anchorWidth: "auto",
              ref: menuRef,
              children: /*#__PURE__*/(0, _jsxRuntime.jsx)("ul", {
                className: styles['cc-SideBar__menu__item__more-menu'],
                children: menuItems.map((item, i) => {
                  const itemProps = {
                    item,
                    isMoreMenuItem: true,
                    onItemClick: handleItemClick
                  };
                  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_SideBarListItem.SideBarListItem, {
                    ...itemProps
                  }, i);
                })
              })
            })
          })]
        })
      })
    })
  });
};
exports.SideBar = SideBar;